// inco theme script: shared effects for every page, the waitlist check and the product picker.

// ---- corner clock ----
const clocks = document.querySelectorAll("[data-clock]");
function tick() {
  const d = new Date();
  const p = (n) => String(n).padStart(2, "0");
  const s = `${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
  clocks.forEach((c) => (c.textContent = s));
}
tick();
setInterval(tick, 1000);
document.querySelectorAll("[data-year]").forEach((el) => (el.textContent = new Date().getFullYear()));

// ---- film grain ----
const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

// ---- tab icon: the sigil with its center line swinging like a metronome ----
// Chrome, Edge and Safari won't play an animated GIF icon, so the icon is
// redrawn on a canvas instead. favicon.svg stays as the still fallback.
(function animateFavicon() {
  const link = document.querySelector('link[rel="icon"]');
  const canvas = document.createElement("canvas");
  canvas.width = canvas.height = 64;
  const ctx = canvas.getContext && canvas.getContext("2d");
  if (!link || !ctx || reduceMotion || typeof Path2D === "undefined") return;

  const parts = [
    "M30 230 V112 Q30 44 100 20 Q170 44 170 112 V230",
    "M139.9 82.5 A62 62 0 1 0 139.9 177.5",
    "M134 130 A34 34 0 1 1 66 130 A34 34 0 1 1 134 130",
    "M20 230 H180",
  ].map((d) => new Path2D(d));
  const diamond = new Path2D("M100 -6 L110 6 L100 18 L90 6 Z");
  const SWING = (13 * Math.PI) / 180;

  function draw(t) {
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, 64, 64);
    ctx.fillStyle = "#07080a";
    ctx.beginPath();
    ctx.roundRect ? ctx.roundRect(0, 0, 64, 64, 10) : ctx.rect(0, 0, 64, 64);
    ctx.fill();
    // same placement as favicon.svg
    ctx.setTransform(0.25, 0, 0, 0.25, 32 - 25, 33 - 28);
    ctx.strokeStyle = ctx.fillStyle = "#d6d9d3";
    ctx.lineWidth = 12;
    ctx.lineCap = ctx.lineJoin = "round";
    parts.forEach((p) => ctx.stroke(p));
    ctx.fill(diamond);
    // the pendulum: 2 s per full swing, easing at each end
    ctx.translate(100, 230);
    ctx.rotate(SWING * Math.sin((2 * Math.PI * t) / 2000));
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(0, -178);
    ctx.stroke();
    link.type = "image/png";
    link.href = canvas.toDataURL("image/png");
  }

  draw(0);
  setInterval(() => draw(performance.now()), 66); // ~15 fps; background tabs slow this down on their own
})();

// ---- inco words surfacing in the background ----
const words = ["incognito", "income", "inconsiderate", "incoherent", "inconsolable", "inconceivable", "incomprehensible", "inconspicuous", "incompatible"];
const drift = document.querySelector("[data-drift]");
const hero = document.querySelector(".hero");
// words stay off the logo, the clothing and the signup
const keepClear = [...document.querySelectorAll(".hero .wordmark, .hero .goods, .hero .rail, .hero .signup")];
let wi = Math.floor(Math.random() * words.length);

function placeWord(el) {
  // try random spots until the word doesn't sit on top of anything in keepClear
  const h = hero.getBoundingClientRect();
  const clear = keepClear.map((k) => k.getBoundingClientRect());
  for (let tries = 0; tries < 30; tries++) {
    const x = 0.04 + Math.random() * 0.8;
    const y = 0.08 + Math.random() * 0.82;
    el.style.left = x * 100 + "%";
    el.style.top = y * 100 + "%";
    const r = el.getBoundingClientRect();
    const apart = (o) => r.right < o.left - 24 || r.left > o.right + 24 || r.bottom < o.top - 16 || r.top > o.bottom + 16;
    const others = [...drift.children].filter((s) => s !== el).map((s) => s.getBoundingClientRect());
    if (clear.every(apart) && others.every(apart) && r.right < h.right - 8) return true;
  }
  return false;
}

function surface(stay = false) {
  const el = document.createElement("span");
  el.textContent = words[wi];
  wi = (wi + 1 + Math.floor(Math.random() * 3)) % words.length;
  el.style.fontSize = (13 + Math.random() * 22).toFixed(0) + "px";
  // some words barely surface, none fully
  el.style.setProperty("--peak", (0.15 + Math.random() * 0.55).toFixed(2));
  drift.appendChild(el);
  if (!placeWord(el)) { el.remove(); return; }
  void el.offsetWidth; // commit the hidden state so the fade-in runs
  el.classList.add("on");
  if (stay) return;
  // hold, then fade back out and clean up
  setTimeout(() => el.classList.remove("on"), 4500 + Math.random() * 3000);
  setTimeout(() => el.remove(), 11000);
}

if (drift && hero && keepClear.length) {
  if (reduceMotion) {
    for (let i = 0; i < 4; i++) surface(true);
  } else {
    surface();
    setInterval(surface, 2600);
  }
}
const grain = document.querySelector("[data-grain]");
grain.width = 240;
grain.height = 160;
const gctx = grain.getContext("2d");
const gimg = gctx.createImageData(grain.width, grain.height);
function drawGrain() {
  const d = gimg.data;
  for (let i = 0; i < d.length; i += 4) {
    const v = (Math.random() * 255) | 0;
    d[i] = d[i + 1] = d[i + 2] = v;
    d[i + 3] = 255;
  }
  gctx.putImageData(gimg, 0, 0);
}
drawGrain();
// phones refresh the grain less often so the clothing strip keeps its frame rate
const grainEvery = window.matchMedia("(pointer: coarse)").matches ? 180 : 90;
if (!reduceMotion) {
  let last = 0;
  (function loop(t) {
    if (t - last > grainEvery) { drawGrain(); last = t; }
    requestAnimationFrame(loop);
  })(0);
}

// ---- clothing feed: an endless strip that pans on its own like a security camera ----
const rail = document.querySelector("[data-rail]");
if (rail) {
  const originals = [...rail.children];
  const n = originals.length;
  const count = rail.closest(".goods").querySelector("[data-count]");
  const pad = (k) => String(k).padStart(2, "0");
  originals.forEach((c, i) => c.querySelector(".shot").setAttribute("data-cam", "CAM " + pad(i + 1)));

  // one track holding the real cards plus copies, so the strip never runs out
  const track = document.createElement("div");
  track.className = "rail-track";
  rail.appendChild(track);
  originals.forEach((c) => track.appendChild(c));
  const copy = () => originals.forEach((c) => {
    const d = c.cloneNode(true);
    d.setAttribute("aria-hidden", "true");
    d.tabIndex = -1;
    track.appendChild(d);
  });
  copy(); copy();
  const cards = [...track.children];

  const SPEED = 38;           // px per second while panning
  let x = 0;                  // track offset, kept within one set
  let v = -SPEED, target = -SPEED;
  // phones get the light version: no blur, no parallax, just the pan and the fade
  const lite = window.matchMedia("(pointer: coarse)").matches;
  if (lite) rail.classList.add("lite");
  // card positions are measured once (and on resize), never per frame
  let setW = 0, railW = 0, lefts = [], widths = [];
  const imgs = cards.map((c) => [...c.querySelectorAll(".shot img")]);
  const shown = cards.map(() => -1);   // last opacity written, to skip no-op style writes
  const measure = () => {
    setW = cards[n].offsetLeft - cards[0].offsetLeft;
    railW = rail.clientWidth;
    lefts = cards.map((c) => c.offsetLeft);
    widths = cards.map((c) => c.offsetWidth);
  };
  measure();
  window.addEventListener("resize", measure);
  const wrap = () => { if (setW) { x %= setW; if (x > 0) x -= setW; } };

  let current = -1;
  let dragging = false, moved = false, downX = 0, lastX = 0, lastT = 0, resume = 0;
  // each frame only moves the track and fades cards (both cheap for the GPU);
  // the blur is a class that changes only when the focused card changes
  function frame() {
    track.style.transform = `translate3d(${x.toFixed(1)}px,0,0)`;
    const mid = railW / 2;
    let best = 0, bestD = Infinity;
    for (let i = 0; i < cards.length; i++) {
      const off = (x + lefts[i] + widths[i] / 2 - mid) / widths[i];   // 0 at center, ±1 one card away
      const a = Math.abs(off);
      if (a < bestD) { bestD = a; best = i; }
      if (a > 3) continue;   // well off screen: leave it alone
      // sharp across the middle third, then fading toward the edges
      const f = Math.max(0, Math.min(1, 1 - (a - 0.35) * 1.1));
      const o = Math.round((0.5 + 0.5 * f) * 50) / 50;
      if (o !== shown[i]) { cards[i].style.opacity = o; shown[i] = o; }
      if (!lite) {
        const px = (off * -14).toFixed(1) + "px";
        imgs[i].forEach((im) => { im.style.translate = px + " 0"; });
      }
    }
    if (best !== current) {
      if (current >= 0) cards[current].classList.remove("on");
      cards[best].classList.add("on");
      current = best;
      count.textContent = `${pad((best % n) + 1)} / ${pad(n)}`;
    }
  }

  if (reduceMotion) {
    // no panning: just a row you can scroll yourself
    cards.slice(n).forEach((c) => c.remove());
    cards.forEach((c) => c.classList.add("on"));
  } else {
    let last = performance.now();
    (function loop(now) {
      const dt = Math.min(0.05, (now - last) / 1000);
      last = now;
      if (!dragging) {
        v += (target - v) * Math.min(1, dt * 3);   // ease toward the target speed
        x += v * dt;
        wrap();
      }
      frame();
      requestAnimationFrame(loop);
    })(last);

    // a signal fault on the focused frame every few seconds
    (function glitch() {
      setTimeout(() => {
        const c = cards[current];
        if (c && !document.hidden) {
          c.classList.add("glitch");
          setTimeout(() => c.classList.remove("glitch"), 340);
        }
        glitch();
      }, 3500 + Math.random() * 4500);
    })();
  }

  // hover slows it to a stop so a piece can be looked at
  rail.addEventListener("pointerenter", (e) => { if (e.pointerType === "mouse") target = 0; });
  rail.addEventListener("pointerleave", (e) => { if (e.pointerType === "mouse") target = -SPEED; });

  // drag or swipe it either way; letting go throws it, then it settles back to panning
  rail.addEventListener("pointerdown", (e) => {
    if (reduceMotion || (e.pointerType === "mouse" && e.button !== 0)) return;
    dragging = true; moved = false;
    downX = lastX = e.clientX; lastT = performance.now();
    clearTimeout(resume);
  });
  window.addEventListener("pointermove", (e) => {
    if (!dragging) return;
    const dx = e.clientX - lastX;
    if (!moved && Math.abs(e.clientX - downX) > 6) { moved = true; rail.classList.add("dragging"); }
    if (!moved) return;
    const now = performance.now();
    x += dx; wrap();
    v = dx / Math.max(0.001, (now - lastT) / 1000);
    lastX = e.clientX; lastT = now;
  });
  const release = (e) => {
    if (!dragging) return;
    dragging = false;
    if (!moved) return;
    rail.classList.remove("dragging");
    v = Math.max(-1800, Math.min(1800, v));
    target = 0;   // coast to a stop...
    resume = setTimeout(() => { if (!rail.matches(":hover")) target = -SPEED; }, 1600);   // ...then pick the pan back up
    rail.addEventListener("click", (ev) => { ev.preventDefault(); ev.stopPropagation(); }, { capture: true, once: true });
  };
  window.addEventListener("pointerup", release);
  window.addEventListener("pointercancel", release);

  // keyboard: tabbing to a piece brings it to the middle and holds it there
  originals.forEach((c) => {
    c.addEventListener("focus", () => {
      target = 0; v = 0;
      const r = c.getBoundingClientRect(), box = rail.getBoundingClientRect();
      x += box.left + box.width / 2 - (r.left + r.width / 2);
      wrap();
    });
    c.addEventListener("blur", () => { target = reduceMotion ? 0 : -SPEED; });
  });
}

// ---- waitlist: Shopify takes the post; this only catches typos first ----
const signup = document.getElementById("signup");
if (signup) {
  const input = signup.querySelector('input[type="email"]');
  const status = document.getElementById("status");
  signup.addEventListener("submit", (e) => {
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim())) return;
    e.preventDefault();
    status.textContent = "incompatible address. check it and try again.";
    status.className = "note err";
    input.focus();
  });
}

// ---- product page: options -> variant, price, button and photo ----
const pjson = document.querySelector("[data-product-json]");
if (pjson) {
  const product = JSON.parse(pjson.textContent);
  const form = document.querySelector("[data-product-form]");
  const idInput = form.querySelector("[data-variant-id]");
  const addBtn = form.querySelector("[data-add]");
  const priceEl = document.querySelector("[data-price]");
  const mainImg = document.querySelector("[data-main]");
  const thumbs = [...document.querySelectorAll("[data-thumb]")];
  const money = (cents) => "$" + (cents % 100 ? (cents / 100).toFixed(2) : cents / 100);

  function show(src, mediaId) {
    if (!mainImg || !src) return;
    mainImg.src = src;
    thumbs.forEach((t) => t.toggleAttribute("aria-current", String(t.dataset.mediaId) === String(mediaId)));
  }
  thumbs.forEach((t) => t.addEventListener("click", () => show(t.dataset.thumb, t.dataset.mediaId)));

  function chosen() {
    return product.options.map((_, i) => {
      const r = form.querySelector(`input[name="opt-${i}"]:checked`);
      return r ? r.value : null;
    });
  }

  function update() {
    const picks = chosen();
    const v = product.variants.find((x) => x.options.every((o, i) => o === picks[i]));
    if (!v) {
      addBtn.disabled = true;
      addBtn.textContent = "unavailable";
      return;
    }
    idInput.value = v.id;
    priceEl.textContent = money(v.price);
    addBtn.disabled = !v.available;
    addBtn.textContent = v.available ? "add to cart" : "gone";
    if (v.featured_media) {
      const t = thumbs.find((x) => String(x.dataset.mediaId) === String(v.featured_media.id));
      show(t ? t.dataset.thumb : v.featured_media.preview_image.src, v.featured_media.id);
    }
    const url = new URL(location.href);
    url.searchParams.set("variant", v.id);
    history.replaceState(null, "", url);
  }
  form.addEventListener("change", (e) => { if (e.target.name && e.target.name.startsWith("opt-")) update(); });
}
